import type { TidalSandbox, TidalSandboxApi } from '@workwave-tidal/sandbox-utils'
import { useMemo } from 'react'
import { storyExists } from '../../utils/parsedTree.js'
import {
  setTidalSandboxGlobalControlsConfig,
  updateTidalSandboxGlobalControlsConfig,
  useSetTidalSandboxStateField,
  useTidalSandboxState,
} from '../atoms/tidalSandboxState.js'
import { useChangeStory } from './useChangeStory.js'

export function useCreateTidalSandboxContext(): {
  tidalSandbox: TidalSandbox
  tidalSandboxApi: TidalSandboxApi
} {
  const changeActiveStory = useChangeStory()

  const tidalSandbox = useTidalSandboxState()

  const setNavigationCollapsed = useSetTidalSandboxStateField('navigationCollapsed')
  const setDisableKeybindings = useSetTidalSandboxStateField('disableKeybindings')
  const setSidebarPosition = useSetTidalSandboxStateField('sidebarPosition')
  const setFullScreen = useSetTidalSandboxStateField('fullScreen')
  const setNavigationWidth = useSetTidalSandboxStateField('navigationWidth')
  const setNavigationDisabled = useSetTidalSandboxStateField('navigationDisabled')
  const setGlobalControlsDisabled = useSetTidalSandboxStateField('globalControlsDisabled')

  const tidalSandboxApi = useMemo<TidalSandboxApi>(() => {
    return {
      setActiveStory: (slug: string) => {
        if (storyExists(slug)) changeActiveStory(slug)
      },
      setDisableKeybindings,
      setFullScreen,
      setGlobalControlsConfig: setTidalSandboxGlobalControlsConfig,
      setGlobalControlsDisabled,
      setNavigationCollapsed,
      setNavigationDisabled,
      setNavigationWidth,
      setSidebarPosition,
      updateGlobalControlsConfig: updateTidalSandboxGlobalControlsConfig,
    }
  }, [
    changeActiveStory,
    setNavigationCollapsed,
    setDisableKeybindings,
    setSidebarPosition,
    setFullScreen,
    setNavigationWidth,
    setNavigationDisabled,
    setGlobalControlsDisabled,
  ])

  return { tidalSandbox, tidalSandboxApi }
}
